import React from 'react'
import { Box, Typography } from '@mui/material'

type AdSlotProps = {
    slotName: string
    width?: number | string
    height?: number | string
}

const AdSlot: React.FC<AdSlotProps> = ({ slotName, width = '100%', height = 120 }) => {
    return (
        <Box
            sx={{
                width,
                height,
                bgcolor: 'background.default',
                border: '1px dashed',
                borderColor: 'divider',
                borderRadius: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'text.secondary',
                backgroundImage: 'repeating-linear-gradient(45deg, rgba(0,0,0,0.04) 0, rgba(0,0,0,0.04) 10px, transparent 10px, transparent 20px)'
            }}
        >
            <Typography variant="caption">AdSense Placeholder • {slotName}</Typography>
        </Box>
    )
}

export default AdSlot


